import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';

import { AuthGuard } from '../auth/services/auth-guard.service';
import { CognitoWrapperService } from '../core/services/congito.wrapper.service';
import { GlobalPortalGuard } from '../core/services/global-guard.service';
import { AdminComponent } from './admin.component';

@NgModule({
  declarations: [AdminComponent],
  imports: [
    StoreModule,
    RouterModule.forChild([
      {
        path: 'admin',
        children: [
          {
            path: '**',
            canActivate: [AuthGuard, GlobalPortalGuard],
            component: AdminComponent,
          },
        ],
      },
    ]),
  ],
  providers: [CognitoWrapperService],
})
export class AdminModule {}
